<script>
    export default {
        inserted: function (el) {
            let videoSection = el.querySelector('.video');
            let videoPopup = el.querySelector('.popup');

             let stopVideos = function () {
                let iframes = el.querySelectorAll('iframe');
                if (iframes.length > 0) {
                    for(let iframe of iframes) {
                        let iframeSrc = iframe.src;
                        iframe.src = iframeSrc;
                    }
                }
            };
            
            let togglePopupVideo = function() {
                stopVideos();
                videoPopup.classList.toggle('active');
            }

            videoSection.onclick = function(e) {
                e.preventDefault();
                togglePopupVideo();
            }

            
        }
    }

</script>
